module.exports = __webpack_public_path__ + "static/media/Golden tower 09.7a1a872f.webp";